import React from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import HomePage from './pages/HomePage';
import MenuPage from './pages/MenuPage';
import EmplacementsPage from './pages/EmplacementsPage';
import AvisPage from './pages/AvisPage';
import AProposPage from './pages/AProposPage';
import ContactPage from './pages/ContactPage';

function App() {
  return (
    <div className="App min-h-screen bg-[#0E0E0E]">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/menu" element={<MenuPage />} />
          <Route path="/emplacements" element={<EmplacementsPage />} />
          <Route path="/avis" element={<AvisPage />} />
          <Route path="/a-propos" element={<AProposPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
